(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["saam-collection-visual"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saam-collection-visual')) {
    customElements.define('saam-collection-visual', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        if (this.classList.contains('saam-collection-visual--hero') || !('IntersectionObserver' in window)) {
          this.loadVisual();
          return;
        }
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.loadVisual();
          }
        });
        this.observer.observe(this);
      }
      loadVisual() {
        this.started = true;
        const sources = [...new Set([this.dataset.preferred, this.dataset.src, this.dataset.alternate, this.dataset.legacy, this.dataset.collection].filter(Boolean))];
        const next = () => {
          const source = sources.shift();
          if (!source) return;
          const image = new Image();
          image.alt = this.dataset.alt || '';
          image.decoding = 'async';
          image.onload = () => {
            this.append(image);
            this.setAttribute('data-loaded', '');
          };
          image.onerror = next;
          image.src = source;
        };
        next();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saam-policy-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-saam-policy]');
  if (!root || root.dataset.enhanced) return;
  const body = root.querySelector('.shopify-policy__body');
  if (!body) return;
  root.dataset.enhanced = 'true';
  const header = root.querySelector('[data-policy-header]');
  const title = root.querySelector('.shopify-policy__title') || root.querySelector('[data-policy-source] h1');
  if (title) header.append(title);
  const updated = [...body.querySelectorAll('p')].find(p => /^(last\s+updated|updated\s+on|effective\s+date)\s*[:??-]?\s*\S/i.test(p.textContent.trim()) && p.textContent.trim().length < 180);
  if (updated) {
    const date = document.createElement('p');
    date.className = 'saam-care__updated';
    date.textContent = updated.textContent;
    header.append(date);
  }
  const headings = [...body.querySelectorAll('h2, h3')].filter(h => h.textContent.trim());
  const list = root.querySelector('[data-policy-toc]');
  headings.forEach((heading, index) => {
    if (!heading.id) {
      let id = `saam-policy-heading-${index + 1}`;
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    }
    const item = document.createElement('li');
    if (heading.tagName === 'H3') item.className = 'saam-care__toc-subheading';
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    link.addEventListener('click', () => {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    });
    item.append(link);
    list.append(item);
  });
  if (headings.length) {
    root.querySelector('[data-policy-sidebar]').hidden = false;
    root.classList.add('saam-care--has-toc');
    const details = root.querySelector('details');
    const desktop = matchMedia('(min-width: 990px)');
    const sync = () => { details.open = desktop.matches; };
    sync();
    desktop.addEventListener('change', sync);
  }
  body.querySelectorAll('table').forEach(table => {
    const scroll = document.createElement('div');
    scroll.className = 'saam-care__table';
    scroll.tabIndex = 0;
    scroll.setAttribute('role', 'region');
    scroll.setAttribute('aria-label', table.caption?.textContent || header.textContent.trim());
    table.before(scroll);
    scroll.append(table);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saam-subcategory-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saam-subcategory-carousel')) {
    customElements.define('saam-subcategory-carousel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rail = this.querySelector('.saam-subcategory-nav__rail');
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail) return;
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.slide((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.rail);
        this.update();
      }
      slide(step) {
        const rtl = getComputedStyle(this.rail).direction === 'rtl';
        this.rail.scrollBy({
          left: step * (rtl ? -1 : 1) * this.rail.clientWidth * .8,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      update() {
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.rail.tabIndex = maximum > 1 ? 0 : -1;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saam-vastu-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saam-vastu-slideshow')) {
    customElements.define('saam-vastu-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('.saam-vastu-slideshow__slide')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = false;
        this.querySelector('.saam-vastu-slideshow__controls').hidden = false;
        this.toggle = this.querySelector('[data-toggle]');
        this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.observer.observe(this);
        this.show();
        this.sync();
      }
      move(step) {
        this.index = (this.index + step + this.slides.length) % this.slides.length;
        this.show();
        this.sync();
      }
      show() {
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
        const next = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
        next.loading = 'eager';
      }
      sync() {
        clearInterval(this.timer);
        this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) this.timer = setInterval(() => this.move(1), 5000);
      }
      disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
